import {
  type CreateWebsiteMarketingTagRequest,
  type UpdateWebsiteMarketingTagRequest,
  type WebsiteMarketingTagDetail,
  WebsiteMarketingTagDetailSchema,
  type WebsiteMarketingTagListQuery,
  type WebsiteMarketingTagListResponse,
  WebsiteMarketingTagListResponseSchema,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Marketing tags (themes / collections) admin API. Every response is validated
 * with the shared Zod schema.
 */

const BASE = '/admin/website/marketing-tags';

export const listMarketingTags = async (
  query: WebsiteMarketingTagListQuery,
): Promise<WebsiteMarketingTagListResponse> => {
  const { data } = await apiClient.get<unknown>(BASE, { params: query });
  return WebsiteMarketingTagListResponseSchema.parse(data);
};

export const getMarketingTag = async (id: string): Promise<WebsiteMarketingTagDetail> => {
  const { data } = await apiClient.get<unknown>(`${BASE}/${id}`);
  return WebsiteMarketingTagDetailSchema.parse(data);
};

export const createMarketingTag = async (
  payload: CreateWebsiteMarketingTagRequest,
): Promise<WebsiteMarketingTagDetail> => {
  const { data } = await apiClient.post<unknown>(BASE, payload);
  return WebsiteMarketingTagDetailSchema.parse(data);
};

export const updateMarketingTag = async (
  id: string,
  payload: UpdateWebsiteMarketingTagRequest,
): Promise<WebsiteMarketingTagDetail> => {
  const { data } = await apiClient.patch<unknown>(`${BASE}/${id}`, payload);
  return WebsiteMarketingTagDetailSchema.parse(data);
};

export const deleteMarketingTag = async (id: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`);
};

export const bulkDeleteMarketingTags = async (
  ids: string[],
): Promise<{ updated: number; failed: { id: string; error: string }[] }> => {
  const { data } = await apiClient.post<{
    updated: number;
    failed: { id: string; error: string }[];
  }>(`${BASE}/bulk-delete`, { ids });
  return data;
};
